/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import _ from 'lodash';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { getRequiredColumnOnExportPDF } from './TableHead';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const contentFont = 10;
const pageMargins = [42, 80, 28.8, 25.92];
const styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 16,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 5, 0, 15],
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
  },
};

const numberFormatter = (value) => {
  if (value < 0) {
    return `(${parseFloat(value)?.toLocaleString('en-US')?.substring(1)})`;
  }
  return value?.toLocaleString('en-US');
};
const getHeader = (currentPage, pageCount, data, options) => {
  const { prinDate, requestedBy, reportName } = data;
  const { pageSize, info } = options;
  const {
    thirdInfo = '',
    fourthInfo = '',
    fifthInfo = '',
    sixthInfo = '',
  } = info;

  let widths = [255, 255, 255];
  if (pageSize && pageSize.width) {
    const w = (pageSize.width - 95) / 3;
    widths = [w, w, w];
  }
  const header = {
    alignment: 'center',
    fontSize: 10,
    margin: [38.8, 24, 28.8, 25.92],
    style: 'tableExample',
    table: {
      widths: widths,
      body: [
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: reportName,
            fontSize: 12,
            bold: true,
            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: [{ text: 'Date Printed: ', bold: true }, prinDate],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: fourthInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: thirdInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: fifthInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: sixthInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: '',
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
  return header;
};

const getTableBodyData = (data, cols, key) => {
  const dataToReturn = [];
  const columns = [];
  for (let i = 0; i < cols.length; i += 1) {
    columns.push({
      text: cols[i].headerName,
      fontSize: contentFont,
      border: [true, true, true, true],
      bold: true,
      alignment: 'left',
    });
  }
  dataToReturn.push(columns);

  for (let i = 0; i < data.length; i += 1) {
    const tempCols = [];
    for (let j = 0; j < cols.length; j += 1) {
      let text = data[i][cols[j].field];

      const TotalBold = data[i]?.jcode_units === 'Grand Total:' || false;
      const boolValue = data[i]?.bold || false;

      if (cols[j].isAmount) {
        text = handleCommaSeparatedAmount(data[i][cols[j].field] || 0);
      } else if (typeof text === 'number') {
        text = numberFormatter(data[i][cols[j].field] || 0);
      }
      if (cols[j]?.field === 'percent_medical' && !data[i]?.isBottomRow) {
        text = `${text} %`;
      }
      tempCols.push({
        text,
        fontSize: boolValue || TotalBold ? contentFont : contentFont - 1,
        border: [true, true, true, true],
        bold: boolValue || TotalBold,
        alignment: cols[j].alignment || 'left',
        color:
          typeof data[i][cols[j].field] === 'number' &&
          data[i][cols[j].field] < 0
            ? 'red'
            : 'black',
      });
    }
    dataToReturn.push(tempCols);
  }
  return dataToReturn;
};
const getTableBody = (data, options, columnApi) => {
  const body = [];
  const dataKeys = Object.keys(data);
  dataKeys.sort();
  const { manufactureID, info } = options;

  for (let i = 0; i < dataKeys.length; i += 1) {
    const cols = getRequiredColumnOnExportPDF(dataKeys[i], columnApi);
    const widths = cols.map((item, index) => (index === 1 ? 200 : '*'));
    const mafactureDetail = manufactureID?.filter((x) => {
      return x.manufacturerID === dataKeys[i];
    });
    let mfgId = '';
    let mfgName = info?.secondInfo;
    if (mafactureDetail?.length > 0) {
      mfgId = `${info?.firstInfo} ${mafactureDetail[0]?.manufacturerID}               `;
      mfgName = `     ${info?.secondInfo} ${mafactureDetail[0]?.manufacturerName}`;
    }
    body.push({
      text: [
        {
          text: mfgId,
          bold: false,
          fontSize: 10,
          fontFamily: 'arial',
          alignment: 'left',
        },
        {
          text: mfgName,
          bold: false,
          fontSize: 10,
          fontFamily: 'arial',
          alignment: 'center',
        },
      ],
    });
    body.push({
      style: 'tableExample',
      table: {
        widths: ['*'],
        body: [
          [
            {
              style: 'tableExample',
              table: {
                headerRows: 1,
                widths: widths,
                body: getTableBodyData(data[dataKeys[i]], cols, dataKeys[i]),
              },
            },
          ],
        ],
      },
      layout: 'noBorders',
    });
    if (i < dataKeys.length - 1)
      body.push({
        text: '',
        fontSize: 14,
        bold: true,
        pageBreak: 'before',
        margin: [0, 0, 0, 8],
      });
  }
  return body;
};

/**
 * Download as PDF with all Data.
 * @param {object} headerData - conatisn header info of PDF.
 * @param {object} bodyData - constains Body data for PDF.
 * @param {object} options - constains additional dara for PDF.
 */
const getPdfData = (bodyData, headerData, options, columnApi) => {
  const { pageSize } = options;
  const content = getTableBody(bodyData, options, columnApi);
  const currentYear = new Date().getFullYear();
  let docDefinition = {
    header: (currentPage, pageCount) => {
      return getHeader(currentPage, pageCount, headerData, options);
    },
    footer: () => {
        const footers = [];
        footers.push({
          text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
          fontSize: 8,
          color: '#636363',
          fontFamily: 'Arial',
          alignment: 'center',
        });

      return footers;
    },
    content,
    pageMargins,
    styles,
    pageOrientation: 'landscape',
  };

  if (pageSize && pageSize?.width && pageSize.height) {
    docDefinition = {
      ...docDefinition,
      pageSize: {
        width: pageSize.width,
        height: pageSize.height,
      },
    };
  }
  return docDefinition;
};

/**
 * Download as PDF with all Data.
 * @param {object} data - header info of PDF.
 * @param {object} userDefaultValues - use info containg object
 */
const getHeaderData = (UserDefaultsValues, options, logInUser) => {
  const { reportName } = options;
  return {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy:
      UserDefaultsValues && UserDefaultsValues.userId
        ? UserDefaultsValues.userId
        : logInUser,
    reportName,
  };
};

/**
 * Download as PDF with all Data.
 * @param {object} header - header info of PDF.
 * @param {object} bodyData - All the data for the PDF.
 * @param {object} userDefaultValues
 */
export const exportAllPDF = (
  bodyData,
  userDefaultValues,
  options = {},
  dispatch,
  logInUser,
  columnApi
) => {
  const headerData = getHeaderData(userDefaultValues, options, logInUser);

  const pdfData = getPdfData(bodyData, headerData, options, columnApi);
  pdfMake
    .createPdf(pdfData)
    .download(
      `${options?.fileName || options?.reportName || 'data'}.pdf`,
      () => {}
    );
};
